import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ToChucVungTrong } from 'src/app/shared/ToChucVungTrong.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class ToChucVungTrongService extends BaseService {
    
    displayColumns001: string[] = ['STT', 'Name', 'Code', 'Note', 'SortOrder', 'Active', 'ToaDo', 'Save'];  

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "ToChucVungTrong";
    }
}

